module.exports = __webpack_public_path__ + "static/img/101212.c3879334.png";